module.exports = __webpack_public_path__ + "img/2025-03-12c_4.710c4a81.jpg";